package org.multiplatform.kotfolio.components

import androidx.compose.runtime.Composable
import com.varabyte.kobweb.compose.css.FontWeight
import com.varabyte.kobweb.compose.css.MinWidth
import com.varabyte.kobweb.compose.css.Overflow
import com.varabyte.kobweb.compose.ui.Modifier
import com.varabyte.kobweb.compose.ui.modifiers.border
import com.varabyte.kobweb.compose.ui.modifiers.borderRadius
import com.varabyte.kobweb.compose.ui.modifiers.display
import com.varabyte.kobweb.compose.ui.modifiers.fontFamily
import com.varabyte.kobweb.compose.ui.modifiers.fontSize
import com.varabyte.kobweb.compose.ui.modifiers.fontWeight
import com.varabyte.kobweb.compose.ui.modifiers.lineHeight
import com.varabyte.kobweb.compose.ui.modifiers.minWidth
import com.varabyte.kobweb.compose.ui.modifiers.overflow
import com.varabyte.kobweb.compose.ui.modifiers.padding
import com.varabyte.kobweb.compose.ui.modifiers.width
import com.varabyte.kobweb.compose.ui.styleModifier
import com.varabyte.kobweb.compose.ui.toAttrs
import com.varabyte.kobweb.framework.annotations.DelicateApi
import com.varabyte.kobweb.silk.style.CssStyle
import com.varabyte.kobweb.silk.style.base
import com.varabyte.kobweb.silk.style.breakpoint.Breakpoint
import com.varabyte.kobweb.silk.style.common.SmoothColorStyle
import com.varabyte.kobweb.silk.style.toModifier
import com.varabyte.kobweb.silk.theme.breakpoint.rememberBreakpoint
import org.jetbrains.compose.web.css.DisplayStyle
import org.jetbrains.compose.web.css.cssRem
import org.jetbrains.compose.web.css.minus
import org.jetbrains.compose.web.css.percent
import org.jetbrains.compose.web.css.px
import org.jetbrains.compose.web.css.times
import org.jetbrains.compose.web.css.vw
import org.jetbrains.compose.web.dom.Code
import org.jetbrains.compose.web.dom.Pre
import org.jetbrains.compose.web.dom.Text

@OptIn(DelicateApi::class)
@Composable
fun KotlinCode(
    code: String) {
    val breakpoint = rememberBreakpoint()

    Pre(attrs = CodeBlockStyle.toModifier()
        .width(if (breakpoint <= Breakpoint.MD) 100.vw  - 20.px * 2 else 900.px)
        .toAttrs()
    ) {
        Code( attrs = SmoothColorStyle.toModifier()
            .display(DisplayStyle.Block).minWidth(MinWidth.MaxContent)
            .styleModifier { property("-webkit-text-size-adjust", 100.percent) }
            .toAttrs()) {
            Text(code)
        }
    }
}


val CodeBlockStyle = CssStyle.base(extraModifier = { SmoothColorStyle.toModifier() }) {
    Modifier
        .borderRadius(10.px)
        .border(1.px)
        .overflow { x(Overflow.Auto) }
        .fontFamily("SFMono-Regular", "Menlo", "Consolas", "monospace")
        .fontSize(12.px)
        .fontWeight(FontWeight.Normal)
        .lineHeight(1.9.cssRem)
        .padding(0.75.cssRem)
}